export default __webpack_public_path__ + "static/marcmakingsense-d02edb14de32196c45de5d9c62b5409b.png";